import { useNavigate } from "react-router";
import { Box, Divider, Typography, useTheme } from "@mui/material";
import { PATHS } from "lib/routing";
import Tags from "lib/components/tags/Tags";
import Page from "lib/components/layout/Page/Page";
import ServicesPageHeader from "../../services/ServicesPageHeader/ServicesPageHeader";
import { sxStyles } from "./TcuServicesPage.styles";

// Hooks
import { useAppDispatch } from "lib/redux/hooks";
import { useAppSelector } from "lib/redux/hooks";
import { selectAppointments } from "ui/appointment/ducks/selectors";
import CompactCard from "lib/components/cards/CompactCard/CompactCard";
import { setTcuSelectedRegInstitutionCode } from "ui/appointment/ducks/appointmentsSlice";
import { logEventToGoogleAnalytics } from "lib/util/GoogleAnalyticsUtil/logEvent";
import { EVENTS } from "lib/util/GoogleAnalyticsUtil/events";

const TcuServicesPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const classes = sxStyles(theme);

  // Redux states
  const location =
    useAppSelector(selectAppointments)?.create?.selectedInstitution || "";
  const remainingTcuRegInstCodes =
    useAppSelector(selectAppointments)?.create?.createTcuAppointment
      ?.remainingRegInstitutionCode || [];

  return (
    <Page>
      {
        <>
          <ServicesPageHeader location={location} />
          <Box sx={classes.noticeContainer}>
            <Typography variant="body2_regular">
              Please confirm the following appointment(s).
            </Typography>
          </Box>
          <Box sx={classes.mainContainer}>
            {remainingTcuRegInstCodes.map((regInstCode: string) => (
              <CompactCard
                key={regInstCode}
                title={
                  regInstCode.endsWith("D")
                    ? "Dental Appointment"
                    : "Medical Appointment"
                }
                tag={<Tags label="Follow-Up" colorChoice="orange" />}
                onClickCard={() => {
                  logEventToGoogleAnalytics(
                    regInstCode.endsWith("D")
                      ? EVENTS.CLICK_TCU_DOMAIN_DENTAL
                      : EVENTS.CLICK_TCU_DOMAIN_MEDICAL,
                  );

                  dispatch(setTcuSelectedRegInstitutionCode(regInstCode));
                  navigate(PATHS.APPOINTMENT_CREATE_TCU_CONFIRM.path);
                }}
              />
            ))}
          </Box>

          <Divider sx={classes.divider} />

          <Box sx={classes.noticeContainer}>
            <Typography variant="body2_regular">
              To book other appointments, tap <b>'Other Services'</b>.
            </Typography>
          </Box>

          <Box sx={classes.mainContainer}>
            <CompactCard
              title="Other Services"
              onClickCard={() => {
                logEventToGoogleAnalytics(EVENTS.CLICK_TCU_DOMAIN_OTHER_SVC);
                // Navigate back to Services Page
                navigate(PATHS.APPOINTMENT_CREATE_SERVICES.path);
              }}
            />
          </Box>
        </>
      }
    </Page>
  );
};

export default TcuServicesPage;
